import {GET_CURRENCY} from "../action_types";

export const getCurrency = () => {
    return {
        type: GET_CURRENCY,
        api: true,
    }
};